import { compose, hoistStatics, withState, withPropsOnChange } from 'recompose';
import { translate } from 'react-i18next';
import Editor from './Editor';

const enhance = compose(
  translate('core'),
  withState('content', 'setContent', ''),
  withPropsOnChange(['content'], props => {
    if (props.value !== props.content) {
      console.log('content chnaged', props.content, props.value);
      props.setValue(props.content);
    }
  }),
  withPropsOnChange(['value'], props => {
    if (props.value !== props.content) {
      props.setContent(props.value);
    }
  }),
);

export default hoistStatics(enhance)(Editor);



// WEBPACK FOOTER //
// ./src/components/cms/editor/index.js